import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles( theme =>
  createStyles({
        vanaDivFlex:{
            textAlign:'center',
            display:'block',
            backgroundColor:'white',
            // height:'100%',
            width:'100%'
        },

        logoSection:{
            height:'131px',
            alignItems: 'end',
            justifyContent: 'center',
            display:'flex',
            maxWidth:'50%',
            margin:'auto'
        },

        textSection:{
            height:'131px',
            [theme.breakpoints.down("md")]:{
                height: '150px', 
            }
        },

        text:{
            color: '#54565A',
            fontWeight: 'bold',
            textAlign:'center',
            margin: '3em 1.5em 0 1.5em',
            
        },

        detailsSection:{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width:'100%',
            height:'131px',
        },

        textVana2:{
            color: '#54565A',
            fontWeight: 'bold',
        },

        divider:{
            marginRight:"-1px",
            background: 'black',
        },

        buttonSection:{
            height:'196px',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
        },

        buttonLearnMore : {
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            // margin: 'auto', 
            display: 'fit-content',
            padding: '0.75rem 1.5rem 0.75rem  1.5rem',
        },

        grid:{
            height:'656px',
            display:'flex', 
            alignItems:'center',
            backgroundColor:'white',
        },

        imgGrid:{
            height:'656px',
            display:'flex', 
            alignItems:'center',
            justifyContent:'center',
            backgroundColor:'white',
            [theme.breakpoints.down("md")]:{
                height:'328px',
            }
        },

        cardImg:{
            width:"100%",
            height:"100%",
            objectFit:"contain"
        },

        detailGrid:{
            textAlign:'center',
            padding: '0 1.5rem 0 1.5rem'
        }

  })
)

export default useStyles;